<template>
  <section id="welcomeScreen">
    <div class="container">
      <div class="logo">
        <img src="img/shaves_logo.svg" alt>
      </div>
      <div class="textCopy">
        <h4>Become a Shaves Loyalty member and</h4>
        <div class="slideContainer">
          <transition-group class="slideTransision" tag="div">
            <div class="frame" v-for="slide in slides" :key="slide.id">
              <h2>{{slide.title}}</h2>
            </div>
          </transition-group>
        </div>
      </div>
      <div class="actions">
        <button @click="toSelection()" class="button is-large is-outlined">
          Join Now
          <span class="icon">
            <i class="fas fa-chevron-right"></i>
          </span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { setInterval } from "timers";
export default {
  name: "welcome",
  data() {
    return {
      counter: 0,
      textItems: null,
      time: 3000,
      slides: [
        { id: 1, title: "Get great discounts & benefits." },
        { id: 2, title: "Be the first to hear about our specials." }
      ]
    };
  },
  methods: {
    toSelection() {
      this.$router.push("/selection");
    },
    clearBodyClasses() {
      document.body.classList.remove("isBusiness", "isPensioner", "isPersonal");
    },
    nextSlide() {
      const first = this.slides.shift();
      this.slides = this.slides.concat(first);
    }
  },
  mounted() {
    setInterval(() => {
      this.nextSlide();
    }, 6000);
  }
};
</script>

